module.exports = __webpack_public_path__ + "images/quote-bg-3c292b86960404d5fe10b888de651d7b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/quote-bg.jpg
 ** module id = 395
 ** module chunks = 0
 **/